import * as _ from 'lodash';
import * as toastr from 'toastr';

import * as UserManagement from '../../';
import * as Common from '../../../../Common/modules';
import * as Models from '../../../../Models';
import * as Services from '../../../../Services';

export interface IEditRoleScope {
  editRoleCtrl: EditRoleCtrl;
}

export class EditRoleCtrl {
  private showLogging: boolean = false;
  private roleList: Models.Auth.RoleList.RoleList = new Models.Auth.RoleList.RoleList();
  public allGroups: Models.GroupModel.IGroupModel[];
  public role: Models.RoleModel.IRoleModel;
  public isSaving = false;
  public alerts = <UserManagement.models.Alert.IAlert[]>[];
  private allPartners: Models.PartnerModel.IPartnerModel[] = [];

  public static $inject = [
    "$scope",
    "$stateParams",
    "$timeout",
    "$state",
    "igs.messageBox",
    "RoleRetrievalService",
    "RoleSaveService",
    "GroupRetrievalService",
    "PartnerRetrievalService",
    "UserService",
  ];

  constructor(
    private $scope: IEditRoleScope,
    private $stateParams: any,
    private $timeout: ng.ITimeoutService,
    private $state: angular.ui.IStateService,
    private messageBox: Common.MessageBox.Igs.Common.IIgsMessageBoxService,
    private roleRetrievalService: UserManagement.services.RoleRetrivalService.IRoleRetrievalService,
    private roleSaveService: UserManagement.services.RoleSaveService.IRoleSaveService,
    private groupRetrievalService: UserManagement.services.GroupRetrievalService.IGroupRetrievalService,
    private partnerRetrievalService: UserManagement.services.PartnerRetrievalService.IPartnerRetrievalService,
    private userService: Services.UserService.IUserService,
  ) {
    $scope.editRoleCtrl = this;
    // Only user admins can edit roles
    this.userService.isUserInRole(this.roleList.manageUsersAdmin).then((response) => {
      if (response === false) {
        this.$state.go("main.customersearchv2");
      }
    });

    this.getAndSetRole($stateParams.id)
      .then(() => this.getAndSetGroups())
      .then(() => this.getAndSetPartners());
  }

  public saveRole = () => {
    if (this.showLogging) {
      console.log("saving role...");
    }
    this.isSaving = true;
    this.roleSaveService
      .saveRole(this.role)
      .then(
        () => toastr.success("Success", "Permission saved successfully"),
        () => toastr.error("Error", "There was a problem saving the permission"),
      )
      .finally(() => {
        this.isSaving = false;
      });
  };

  public selectOrUnselectGroup = (group: Models.GroupModel.IGroupModel) => {
    if (this.showLogging) {
      console.log("group button clicked...");
    }
    if (this.groupIsSelected(group)) {
      this.role.groups = _.filter(this.role.groups, (g: Models.GroupModel.IGroupModel) => g.groupId !== group.groupId);
    } else {
      this.role.groups.push(group);
    }
  };

  public getButtonClass = (group: Models.GroupModel.IGroupModel) => {
    return this.groupIsSelected(group) ? "cyan-btn" : "";
  };

  public groupIsSelected = (group: Models.GroupModel.IGroupModel) => {
    return this.role && _.some(this.role.groups, (g: Models.GroupModel.IGroupModel) => g.groupId === group.groupId);
  };

  public deleteRole = () => {
    if (this.showLogging) {
      console.log("deleting role...");
    }
    var confirm = this.messageBox.open("Delete Permission", "Are you sure you want to delete this permission?", [
      { label: "No", result: false, cssClass: "btn btn-default" },
      { label: "Yes", result: true, cssClass: "btn btn-default cyan-btn" },
    ]);

    confirm.then((result: boolean) => {
      if (result) {
        this.roleSaveService.deleteRole(this.role.roleId).then(
          () => {
            toastr.success("Permission Deleted", "Success");
            this.$state.go("main.usermanagement.search.roles");
          },
          () => toastr.error("Could not delete role", "Error"),
        );
      }
    });
  };

  private getAndSetPartners(): ng.IPromise<void> {
    if (this.showLogging) {
      console.log("getting all partners...");
    }
    return this.partnerRetrievalService.getPartners().then((partners: Models.PartnerModel.IPartnerModel[]) => {
      this.allPartners = _.sortBy(partners, "name");
    });
  }

  private getAndSetGroups(): ng.IPromise<void> {
    if (this.showLogging) {
      console.log("getting all groups...");
    }
    return this.groupRetrievalService.getAllGroupSummaries().then((groups: Models.GroupModel.IGroupModel[]) => {
      this.allGroups = _.sortBy(groups, "name");
    });
  }

  private getAndSetRole(roleId: string): ng.IPromise<void> {
    if (this.showLogging) {
      console.log("getting role...");
    }
    return this.roleRetrievalService.getRoleById(roleId).then((role: Models.RoleModel.IRoleModel) => {
      this.role = role;
    });
  }
}
